module.exports = __webpack_public_path__ + "media/img/404-24429075ecf953e9c14d3505a28f6281.svg";